import { render } from "./CustomerGrid.vue?vue&type=template&id=38fa3a1b"
import script from "./CustomerGrid.vue?vue&type=script&lang=js"
export * from "./CustomerGrid.vue?vue&type=script&lang=js"

import "./CustomerGrid.vue?vue&type=style&index=0&id=38fa3a1b&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__